import { registerMutation, useMutation } from 'data-fetching-client';
import { hubletApi, resolveApi } from 'hub-http/middlewares/core';
import { userPreferencesPath } from '../../consts';
import noPortalClient from 'hub-http/clients/noPortalApiClient';
import { GET_USER_BY_ID, GET_USER_BY_USERNAME, useUserByAuth } from '../users/userQueries';
export const getAvatarUrl = (avatarHash, query, avatarSize = 216) => {
  return `https://${resolveApi(hubletApi('app', 'hubspot'))}/hubsettings/v1/avatar/hash/${avatarHash}/${avatarSize}?${new URLSearchParams(query)}`;
};
export const UPLOAD_AVATAR = registerMutation({
  fieldName: 'uploadAvatar',
  args: ['blob'],

  fetcher({
    blob
  }) {
    return noPortalClient.post(`${userPreferencesPath}/avatar/upload`, {
      data: blob,
      headers: {
        'content-type': 'image/png'
      }
    });
  }

});
export const DELETE_AVATAR = registerMutation({
  fieldName: 'deleteAvatar',
  args: [],

  fetcher() {
    return noPortalClient.delete(`${userPreferencesPath}/avatar`);
  }

});
export const useAvatar = () => {
  const {
    user
  } = useUserByAuth();

  const update = cache => {
    if (!user) return;
    const avatarLastUpdated = Date.now();
    cache.writeQuery({
      query: GET_USER_BY_USERNAME,
      data: {
        userByUsername: Object.assign({}, user, {
          avatarLastUpdated
        })
      },
      variables: {
        username: user.userName
      }
    });
    cache.writeQuery({
      query: GET_USER_BY_ID,
      data: {
        userById: Object.assign({}, user, {
          avatarLastUpdated
        })
      },
      variables: {
        userId: user.userId
      }
    });
  };

  const [uploadAvatar, {
    loading: avatarUploadLoading
  }] = useMutation(UPLOAD_AVATAR, {
    update
  });
  const [deleteAvatar, {
    loading: avatarDeleteLoading
  }] = useMutation(DELETE_AVATAR, {
    update
  });
  return {
    uploadAvatar,
    deleteAvatar,
    avatarUploadLoading,
    avatarDeleteLoading
  };
};